import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

@Injectable()
export class GlobalHttpErrorInterceptor implements HttpInterceptor {
  private globalErrorHandler = inject(GlobalErrorHandlerService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          this.globalErrorHandler.handleError(error);
        }

        return throwError(() => error);
      }),
    );
  }
}
